import _typeof from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/typeof.js";
/* eslint-disable */
/* 任务弹框组件
 * <component-task-box type="1" :task="task"></component-task-box>
 * type:页面类型，1.商详页  2.任务详情页
 * :task：任务数据，必传
 * window.componentCenter.taskBox.showTaskBox=true; //任务详情页显示已领取任务弹框
 */
export default {
  name: "task_box",
  data: function data() {
    return {
      showTaskBox: false,
      //任务弹框
      showOutAnimation: false //展示关闭弹框动画
    };
  },

  props: {
    type: {},
    task: {
      default: {}
    }
  },
  mounted: function mounted() {
    _typeof(window.componentCenter) == "object" || (window.componentCenter = {});
    window.componentCenter.taskBox = this;
    console.log("ycf组件初始化：taskBox");
    //localStorage.removeItem("task_box_" + this.task.taskId);
    if (this.type == 1 && this.task.taskId && !localStorage.getItem("task_box_" + this.task.taskId)) {
      this.$nextTick(function () {
        this.showTaskBox = true;
        $(".scroll-area").css("overflow-y", "hidden");
        localStorage.setItem("task_box_" + this.task.taskId, true);
      });
    }
  },
  methods: {
    //隐藏弹框
    hideBox: function hideBox() {
      var that = this,
        timer = null;
      this.showOutAnimation = true;
      timer = setTimeout(function () {
        clearTimeout(timer);
        that.showOutAnimation = false;
        that.showTaskBox = false;
        that.type == 1 && $(".scroll-area").css("overflow-y", "");
      }, 200);
    },
    //通用锚点事件
    generalAnchors: function generalAnchors(element_content, callback) {
      YCF_Plugin.reportUserAnchors({
        event_id: "520006",
        properties: {
          element_content: element_content
        }
      }).always(callback);
    },
    //跳转到任务详情页、拉新任务页
    goTaskDetailsPage: function goTaskDetailsPage() {
      var that = this;
      this.generalAnchors("clickGetTaskBtn", function () {
        if (that.task.type == 2) {
          //任务详情页
          window.location.href = "/front/promoter/taskDetails?weChatId=1" + "&taskId=" + that.task.taskId;
        } else if (that.task.type == 3) {
          //拉新任务页
          window.location.href = "/front/promoter/recruitTaskDetail?weChatId=1" + "&taskId=" + that.task.taskId;
        } else {
          console.log("错误任务类型！");
        }
      });
    },
    //格式化日历，例：2019-05-28 20:00
    getFormatDate: function getFormatDate(timeStamp) {
      var dateObj = {};
      if (+timeStamp) {
        dateObj = new Date(timeStamp * 1000);
      } else {
        dateObj = new Date();
      }
      var year = dateObj.getFullYear(),
        month = dateObj.getMonth() + 1,
        day = dateObj.getDate(),
        hour = dateObj.getHours(),
        minute = dateObj.getMinutes();
      month < 10 && (month = "0" + month);
      day < 10 && (day = "0" + day);
      hour < 10 && (hour = "0" + hour);
      minute < 10 && (minute = "0" + minute);
      return year + "-" + month + "-" + day + " " + hour + ":" + minute;
    }
  }
};